"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RectangleView = exports.RelativeContainer = exports.PositionedView = exports.TranslatedView = void 0;
var ViewWithStyle_1 = require("./ViewWithStyle");
/**
 * provide props translateX and/or translateY for a translated view
 */
exports.TranslatedView = ViewWithStyle_1.ViewWithStyle(function (_a) {
    var translateX = _a.translateX, translateY = _a.translateY;
    return ({
        transform: [
            { translateX: translateX || 0 },
            { translateY: translateY || 0 },
        ]
    });
});
/**
 * applies an absolute position
 * uses props x and y rather than top and left
 */
exports.PositionedView = ViewWithStyle_1.ViewWithStyle(function (_a) {
    var x = _a.x, y = _a.y;
    return ({
        position: 'absolute',
        top: y,
        left: x,
    });
});
/**
 * a View with position="relative" so that it can be used as a parent container for absolute positioned children
 */
exports.RelativeContainer = ViewWithStyle_1.ViewWithStyle({
    position: "relative",
});
/**
 * rectangle view combines fixed size with absolute position, for placing views with rectangle props x, y, width,
 * height at the correct position and size
 */
exports.RectangleView = ViewWithStyle_1.ViewWithStyle(function (_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    return ({
        position: 'absolute',
        top: y,
        left: x,
        width: width,
        height: height,
        overflow: 'hidden'
    });
});
//# sourceMappingURL=Position.js.map